import clsx from 'clsx';
import { h, Fragment } from 'preact';

const ScentColors = ({ scentColors, isProductCard = false, customClass = '' }) => (
  <>
    {scentColors.length > 0 && (
      <div className={clsx('flex items-center justify-start gap-x-[14px] flex-wrap', isProductCard && 'mb-2', !isProductCard && 'mb-[23px] px-5 laptop:px-0', customClass)}>
        {scentColors.map((sceneColor) => (
          <div
            key={sceneColor.color_text}
            className={'flex items-center justify-start gap-[6px]'}
          >
            <span
              style={{
                backgroundColor: sceneColor.color,
              }}
              className={'w-2 h-2 rounded-[50px] inline-block'}
            ></span>
            <span className={'utility-1 text-charcoal capitalize tracking-[1px]'}>
              {sceneColor.color_text}
            </span>
          </div>
        ))}
      </div>
    )}
  </>
);

export default ScentColors;
